import {connect} from 'react-redux';
import {createSelector} from 'reselect';

import {makeMapStateToProps} from '../../../../helpers/reselectHelpers';
import {SettingsAppsAppDetailsUrl} from '../../../../models/url/settingsUrlModel';
import {AppState} from '../../../../store/appState';
import {getIntegrationsByType} from '../../../../store/data/dataSelectors';
import {
  getIntegrationTypes,
  getIsIntegrationTypesLoading,
} from '../../../../store/data/integrationTypes/integrationTypesSelectors';
import {SettingsAppsDetailsPage} from './settingsAppsDetailsPage';

/*
 * Props.
 */

interface SettingsAppsDetailsPageContainerProps {
  url: SettingsAppsAppDetailsUrl;
}

/*
 * Selectors.
 */

function getUrl(_state: AppState, props: SettingsAppsDetailsPageContainerProps) {
  return props.url;
}

const getIntegrationTypeFromUrl = createSelector(
  [getIntegrationTypes, getUrl],
  (integrationTypes, url) => integrationTypes[url.appId],
);

const getIntegration = createSelector(
  [getIntegrationTypeFromUrl, getIntegrationsByType],
  (integrationType, integrations) => (integrationType ? integrations[integrationType.id] : undefined),
);

/*
 * Redux.
 */

const mapStateToProps = makeMapStateToProps<SettingsAppsDetailsPageContainerProps>()(() => ({
  integrationType: getIntegrationTypeFromUrl,
  integration: getIntegration,
  isIntegrationTypesLoading: getIsIntegrationTypesLoading,
}));

export const SettingsAppsDetailsPageContainer = connect(mapStateToProps)(SettingsAppsDetailsPage);
